<template>
  <div class="import-tool">
    <Modal v-model="visible" title="导入" :mask-closable="false" width="670" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="basic-info-box">
        <span class="title">基本信息</span>
        <CheckboxGroup v-model="basicActiveValue" class="check-group">
          <Checkbox :label="item.name" class="check" v-for="(item, index) in basicInfo" :key="index" :disabled="item.isMust">
            <span class="label-name" :class="{'disabled':item.isMust}">{{ item.name }}</span>
            <Poptip
              trigger="hover"
              placement="top-start"
              :offset="-24"
              transfer-class-name="my-poptip"
              v-if="item.tips"
            >
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ item.tips }}</span>
              </div>
            </Poptip>
          </Checkbox>
        </CheckboxGroup>
      </div>

      <div class="basic-info-box">
        <span class="title">补充信息</span>
        <CheckboxGroup v-model="supplementaryValue" class="check-group">
          <Checkbox :label="item.name" class="check" v-for="(item, index) in supplementaryInfo" :key="index" :disabled="item.isMust">
            <span class="label-name" :class="{'disabled':item.isMust}">{{ item.name }}</span>
            <Poptip
              trigger="hover"
              placement="top-start"
              :offset="-24"
              transfer-class-name="my-poptip"
              v-if="item.tips"
            >
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ item.tips }}</span>
              </div>
            </Poptip>
          </Checkbox>
        </CheckboxGroup>
      </div>

      <div class="basic-info-box">
        <span class="title">需求信息</span>
        <CheckboxGroup v-model="demandValue" class="check-group">
          <Checkbox :label="item.name" class="check" v-for="(item, index) in demandInfo" :key="index" :disabled="item.isMust">
            <span class="label-name" :class="{'disabled':item.isMust}">{{ item.name }}</span>
            <Poptip
              trigger="hover"
              placement="top-start"
              :offset="-26"
              transfer-class-name="my-poptip"
              v-if="item.tips"
            >
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ item.tips }}</span>
              </div>
            </Poptip>
          </Checkbox>
        </CheckboxGroup>
      </div>

      <div class="btn-box">
        <div class="cancel" @click="visible=false"><a>取消</a></div>
        <div class="confirm" @click="confirm"><a>确认</a></div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible:false,
      basicInfo:[],//基础信息
      basicActiveValue: [],

      supplementaryInfo:[],//补充信息
      supplementaryValue:[],

      demandInfo:[],//需求信息
      demandValue:[]
    };
  },
  methods: {
    open(){
      this.getExportData();
      this.visible = true;
    },

    // 获取选项数据
    getExportData() {
      this.$http({
        url: "/buz/customerBase/exportFields",
        type: "GET",
      }).then((res) => {
        const { list1, list2, list3 } = res.data;
        this.dealData('basicInfo', list1, 'basicActiveValue');
        this.dealData('supplementaryInfo', list2, 'supplementaryValue');
        this.dealData('demandInfo', list3, 'demandValue');
      })
    },

    // 处理选项数据
    dealData(list, listData, valueNameList){
      return this[list] = listData.map(item=>{
        if(item.isMust || item.isExist){
          this[valueNameList].push(item.name)
        }
        return {            
          ...item,
          isMust:item.isMust?true:false,
        }
      })
    },

    // 确认提交
    confirm() {
      // 按着列表渲染顺序处理提交参数
      let data = [];
      this.basicInfo.map(item=>{
        this.basicActiveValue.map(item2=>{
          if(item.name == item2){
            data.push(item2)
          }
        })
      })

      this.supplementaryInfo.map(item=>{
        this.supplementaryValue.map(item2=>{
          if(item.name == item2){
            data.push(item2)
          }
        })
      })

      this.demandInfo.map(item=>{
        this.demandValue.map(item2=>{
          if(item.name == item2){
            data.push(item2)
          }
        })
      })
      // 去重
      const result = Array.from(new Set(data));
      this.$http({
        url: "/buz/customerBase/importTemplateConfig",
        type: "POST",
        data:result
      }).then((res) => {
        if(res.httpCode){
          this.$Message.success("设置成功");
          this.visible = false;
          this.basicActiveValue = [];
          this.supplementaryValue = [];
          this.demandValue = [];
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
  .ivu-modal-body {
    padding-bottom: 40px;
  }
  .ivu-modal-header-inner{
    font-size: 14px;
    font-weight: bold;
    color: #3C464F;
  }
  .ivu-modal-close{
    top: 4px ;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #A8ADB7;
    }
  }
  .ivu-modal-header{
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .basic-info-box {
    margin-top: 20px;
    .title {
      display: block;
      font-size: 12px;
      color: #515C6F;
      font-weight: bold;
    }
    .check-group {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      
      .check {
        margin-top: 10px;
        width: 23.6%;
        span {
          margin-left: 4px;
        }
        & .disabled {
          color: #515C6F;
        }
        .tip-icon {
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #ccc;
          color: #ccc;
          display: inline-block;
          text-align: center;
          line-height: 15px;
          font-size: 12px;
          cursor: pointer;
          top: 50%;
        }
        .label-name {
          font-size: 12px;
        }
      }
    }
  }
  .btn-box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cancel {
      border: 1px solid #236DFF;
      border-radius: 2px;
      width: 100px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;      
      a {
        display: block;
        color: #236DFF;
        font-size: 12px;
      }
    }
    .confirm {
      margin-left: 20px;
      background-color: #236DFF;
      border-radius: 2px;
      width: 100px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        display: block;
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
